import manualFront from './manual/front.json';
import manualBack from './manual/back.json';

export default {
  manual: {
    'identity-document-front': manualFront,
    'identity-document-back': manualBack
  }
};
